import { useSelector } from 'react-redux';
import { IS_THAILAND } from '../../utils/datePicker';

/**
 * Custom hook to get the date format from Redux state with Thailand override
 * @returns {string} The date format string (e.g., 'MM/DD/YYYY' or 'DD/MM/YYYY')
 */
export const useDateFormat = () => {
  const dateFormat = useSelector(
    (state) => state?.uiState?.remoteConfig?.date_format || 'MM/DD/YYYY'
  );
  
  // Override date format for Thailand
  return IS_THAILAND ? 'DD/MM/YYYY' : dateFormat;
};
